import { rehydrateDateAfterJsonization as w } from "../util/date-utils.js";
export default class ti {
  constructor(t, i, s, l, h) {
    (this.endpoint = t),
      (this.Mn = i),
      (this.publicKey = s),
      (this.Vl = l),
      (this.al = h),
      (this.endpoint = t || null),
      (this.Mn = i || null),
      (this.publicKey = s || null),
      (this.Vl = l || null),
      (this.al = h || null);
  }
  ss() {
    return {
      e: this.endpoint,
      c: this.Mn,
      p: this.publicKey,
      u: this.Vl,
      v: this.al,
    };
  }
  static Yn(t) {
    return new ti(t.e, w(t.c), t.p, t.u, t.v);
  }
}
